import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FieldLabel from '../FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       onChange - function
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function IncrementByOne({ action, handleIncrement, handleDecrement, field, labelText, handleEditingInput, handleEditingInputChange, editable, setState }) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(action.fields[field]?.value);
    const editInputRef = useRef();
    const inputButtonRef = useRef();
    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-ACTIONS.PAGINATION.';


    useEffect(() => {
        setInputValue(action.fields[field]?.value)
    }, [action.fields[field]?.value])

    const editInput = () => {
        if (editable) {
            editInputRef.current.style.width = action.fields[field]?.value.toString().length + 'ch';
            editInputRef.current.type = "text"
            editInputRef.current.focus()
            inputButtonRef.current.style.display = "none"
        }
    }

    const handleBlur = (event) => {
        handleEditingInput(field, setState, event.target.value)
        editInputRef.current.type = "hidden"
        inputButtonRef.current.style.display = "inline-block"
    }

    const handleChange = (event) => {
        handleEditingInputChange(field, setState, event.target.value)
    }

    const adjustWidth = (event) => {
        const input = event.target;
        input.style.width = input.value.length + 'ch';
    };


    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + labelText)} />
                <ButtonGroup size="small" aria-label="small outlined button group">
                    <Button onClick={handleIncrement}>+</Button>
                    <Button ref={inputButtonRef}  onClick={editInput}>{action.fields[field]?.value}</Button>
                    <input
                        ref={editInputRef}
                        onInput={adjustWidth}
                        name="incrementState"
                        type="hidden"
                        className="increment-edit-input"
                        value={inputValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        />
                    <Button onClick={handleDecrement}>-</Button>
                </ButtonGroup>

                <small className="small-helper">{t(label + labelText + '-HELPER')}</small>
            </div>
            {/* <div className="conf-field-container">
                <strong>{t(label + 'HELP-TEXT')}</strong>
            </div> */}
        </>
    );
}
export default IncrementByOne;